import { Logging, Permission, UserInfo } from '../..';

export enum PermissionGroup {
  BulkUpload = 'bulk_upload',
  Certificates = 'certificates',
  Contacts = 'contacts',
  Correspondence = 'correspondence',
  CorrespondenceConfiguration = 'correspondence_configurations',
  Customers = 'customers',
  Reports = 'reports',
  Settings = 'settings',
  ECWizard = 'ec_wizard',
}

export function getPermission(userInfo: UserInfo, group: PermissionGroup): Permission {
  if (userInfo && userInfo.permissions) {
    const permission: Permission = userInfo.permissions[group?.toString()];

    if (permission) {
      return permission;
    }

    Logging.Error('Unknown Permission Group:', group);
  }

  if (userInfo) {
    Logging.Error('Invalid Permissions', userInfo, group);
  }

  return null;
}

export function getCreatePermission(userInfo: UserInfo, group: PermissionGroup): boolean {
  if (userInfo && userInfo.permissions) {
    const permission: Permission = userInfo.permissions[group?.toString()];

    if (permission) {
      return permission.create;
    }

    Logging.Error('Unknown Permission Group:', group);
  }

  if (userInfo) {
    Logging.Error('Invalid Permissions', userInfo, group);
  }

  return false;
}

export function getEditPermission(userInfo: UserInfo, group: PermissionGroup): boolean {
  if (userInfo && userInfo.permissions) {
    const permission: Permission = userInfo.permissions[group?.toString()];

    if (permission) {
      return permission.edit;
    }

    Logging.Error('Unknown Permission Group:', group);
  }

  if (userInfo) {
    Logging.Error('Invalid Permissions', userInfo, group);
  }

  return false;
}

export function getViewPermission(userInfo: UserInfo, group: PermissionGroup): boolean {
  if (userInfo && userInfo.permissions) {
    const permission: Permission = userInfo.permissions[group?.toString()];

    if (permission) {
      return permission.view;
    }

    Logging.Error('Unknown Permission Group:', group);
  }

  if (userInfo) {
    Logging.Error('Invalid Permissions', userInfo, group);
  }

  return false;
}
